<ul class="footer-links" [ngClass]="{ 'white-text': isWhiteText }">
  <li>
    <a
      href="https://firstorion.com/first-orion-global-privacy-and-compliance-dashboard/"
      target="_blank"
      rel="noopener noreferrer"
    >
      First Orion Legal Dashboard
    </a>
  </li>
  <li>
    <a
      href="https://firstorion.com/legal/acceptable-use-policy-euro/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Acceptable Use
    </a>
  </li>
  <li>
    <a href="#" (click)="openPrivacyChoices($event)">
      <img src="assets/images/privacy-choice.svg" alt="Privacy Icon" />
      Your Privacy Choices</a
    >
  </li>
  <li>
    <small>&copy; 2026 First Orion | All rights reserved.</small>
  </li>
</ul>
